import React from 'react';

import RoutesLogin from './RoutesLogin';
const LoginIn = () => {
  return <RoutesLogin />;
};
export default LoginIn;
